/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable no-undef */

import h from '../../helpers/common';
import { ICatchupEntries } from '@intigral/domain/lib/entity/interface/iCmsCarousel';
import { MpxTag, TuningURLs, IChannelImage, IListings } from '@intigral/domain/lib/entity/interface/common';

export type ITransformedCatchUp = {
    Id: string;
    title: string;
    seriesTitle?: string;
    guid: string;
    paId: string;
    description: string;
    descriptionEn: string;
    year: number;
    tags: MpxTag[];
    genre: string[];
    ratings: string;
    duration: number;
    subscriptionGuids: string[] | null;
    dateTime: string;
    startTime: string;
    listingId: string;
    listingGuid: string;
    endTime: string;
    stationId: string;
    count: number;
    channelId: string;
    stationCallSign: string;
    channelGuid: string;
    tuningURLs: TuningURLs;
    coverImage: string;
    posterImage: string;
    category?: string;
    seriesId?: string | null;
    tvSeasonNumber?: number | null;
    tvSeasonEpisodeNumber?: number | null;
    programType: string;
};

export const catupListTransformer = (catchupData: ICatchupEntries): ITransformedCatchUp => {
    try {
        const listingObj: IListings = catchupData?.listings?.length > 0 ? catchupData.listings[0] : null;
        let coverImage,
            posterImage = '';
        if (catchupData?.images?.length) {
            coverImage = catchupData.images.find((img) => img?.type === 'cover')?.url;
            posterImage = catchupData.images.find((img) => img?.type === 'poster')?.url;
        }
        let duration = catchupData?.runtime ?? 0;
        if (!duration && listingObj?.endTime && listingObj?.startTime) {
            duration =
                Math.round(new Date(listingObj.endTime || '').getTime() / 1000) -
                Math.round(new Date(listingObj.startTime || '').getTime() / 1000);
        }

        const programType =
            catchupData?.assetType === 'LINEAR' &&
            (catchupData?.programType === 'episode' || catchupData?.programType === 'movie')
                ? 'Catchup'
                : catchupData?.assetType === 'VOD' && catchupData?.programType === 'episode'
                ? 'series'
                : 'movie';

        const seriesGuid = catchupData?.seriesId?.split('/')?.pop();

        const result = {
            Id: catchupData.id,
            name: catchupData.title,
            seriesTitle: h.getLang() === 'en' ? catchupData?.seriesTitle : catchupData?.seriesTitleLocalized,
            guid: listingObj?.guid || seriesGuid || '',
            paId: catchupData.id,
            count: catchupData.count,
            title: h.getLang() === 'en' ? catchupData.title : catchupData?.titleLocalized?.['ar'] ?? '',
            description:
                h.getLang() === 'en' ? catchupData.description : catchupData?.descriptionLocalized?.['ar'] ?? '',
            descriptionEn: catchupData.description,
            genre: catchupData?.tags?.filter((i) => i.scheme === 'Genre' && i.title)?.map((el) => el.title) ?? [],
            ratings: h.getGenreRating(catchupData.ratings),
            category: catchupData?.assetType,
            duration: duration,
            dateTime: listingObj?.startTime ?? '',
            startTime: listingObj?.startTime ?? '',
            listingId: listingObj?.id,
            listingGuid: listingObj?.guid || listingObj?.listingGuid,
            endTime: listingObj?.endTime,
            stationId: listingObj?.stationId || '',
            channelId: catchupData.channelId,
            stationCallSign: catchupData.stationCallSign,
            channelGuid: catchupData.channelGuid,
            tvSeasonNumber: catchupData?.tvSeasonNumber,
            seriesId: catchupData.seriesId,
            tvSeasonEpisodeNumber: catchupData?.tvSeasonEpisodeNumber,
            year: catchupData.year,
            tags: catchupData.tags,
            tuningURLs: catchupData.tuningURLs,
            subscriptionGuids: catchupData.subscriptionGuids,
            coverImage: coverImage,
            posterImage: posterImage,
            programType,
        };
        return result;
    } catch (error) {
        return null;
    }
};
